// extracted by mini-css-extract-plugin
export var filterIncDec = "_co-0";
export var leftBorder = "_co-1";
export var rightBorder = "_co-2";
export var stringInput = "_co-3";